import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CandidatureFormation} from '../candidature-formation.model';
import {VTotauxFormationsAvisAdmission} from '../v-totaux-formations-avis-admission.model';
import {VTotauxFormationsAvisAdmissionService} from '../v-totaux-formations-avis-admission.service';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../../cadens.constants';
import {Formation, FormationService} from '../../formation';
import {ListeChoixService} from '../../../shared/ListeChoix/listeChoix.service';
import {ListeChoix} from '../../../shared/ListeChoix/listeChoix.model';

@Component({
    selector: 'jhi-avis-component',
    templateUrl: './avis.component.html'
})
export class AvisComponent implements OnInit {
    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() avisEnabled: number;
    @Input() dateLimiteAvis: number;

    @Output() candidatureFormationChange: EventEmitter<CandidatureFormation> = new EventEmitter();

    listeCommentaires: ListeChoix[];
    listeAvis: string[];
    constants = CONSTANTS;

    // Définition typée de formationStats
    formationStats: {
        idDiplome: number;
        diplome: string;
        nombrePlaces: number;
        totalCandidatures: number;
        totalAvisFavorable: number;
        totalAvisLc: number;
        totalAdmis: number;
        totalLc: number;
    } = {
        idDiplome: 0,
        diplome: '',
        nombrePlaces: 0,
        totalCandidatures: 0,
        totalAvisFavorable: 0,
        totalAvisLc: 0,
        totalAdmis: 0,
        totalLc: 0
    };

    constructor(
        private listeChoixService: ListeChoixService,
        private vTotauxFormationsAvisAdmissionService: VTotauxFormationsAvisAdmissionService,
        private formationService: FormationService
    ) {}

    ngOnInit() {
        this.loadAvisList();
        this.loadCommentaires();
    }

    loadAvisList() {
        this.listeChoixService.query({type: CONSTANTS.AVIS}).subscribe(
            (res: Response) => {
                this.listeAvis = res.json().map(avis => avis.code);
                if (this.candidatureFormation.formationId != null) {
                    this.calculTotauxAvisFormation(this.candidatureFormation.formationId);
                    this.checkFormationLC(this.candidatureFormation.formationId);
                }
            }
        );
    }

    loadCommentaires() {
        this.listeChoixService.query({type: CONSTANTS.COMMENTAIRE}).subscribe(
            (res: Response) => {
                this.listeCommentaires = res.json();
            }
        );
    }

    calculTotauxAvisFormation(formationId: number) {
        this.vTotauxFormationsAvisAdmissionService.find(formationId).subscribe(
            (totauxFormationsAvisAdmission: VTotauxFormationsAvisAdmission) => {
                this.formationStats = {
                    idDiplome: totauxFormationsAvisAdmission.idDiplome,
                    diplome: totauxFormationsAvisAdmission.diplome,
                    nombrePlaces: totauxFormationsAvisAdmission.nombrePlaces,
                    totalCandidatures: totauxFormationsAvisAdmission.totalCandidatures,
                    totalAvisFavorable: totauxFormationsAvisAdmission.totalAvisFavorable,
                    totalAvisLc: totauxFormationsAvisAdmission.totalAvisLc,
                    totalAdmis: totauxFormationsAvisAdmission.totalAdmis,
                    totalLc: totauxFormationsAvisAdmission.totalLc
                };
            },
            (error) => {
                console.error('Erreur lors de la récupération des totaux:', error);
            }
        );
    }

    checkFormationLC(formationId: number) {
        this.formationService.findPourEtudiant(formationId, this.candidatureFormation.userId).subscribe(
            (formation: Formation) => {
                if (!formation.lc) {
                    this.listeAvis = this.listeAvis.filter(avis => avis !== CONSTANTS.AWAITING);
                }
            }
        );
    }

    // Méthode pour afficher "Non renseigné" si la valeur est null, undefined ou 0
    getDisplayValue(value: any): string {
        if (value === null || value === undefined || value === 0) {
            return 'Non renseigné';
        }
        return value.toString();
    }

    chooseAvis(avis: string) {
        this.candidatureFormation.avis = this.candidatureFormation.avis === avis ? null : avis;
        this.candidatureFormation.avisRang = avis !== CONSTANTS.AWAITING ? null : this.candidatureFormation.avisRang;
        this.candidatureFormation.commentaire = avis !== CONSTANTS.NOTFAVORABLE ? null : this.candidatureFormation.commentaire;
        this.candidatureFormationChange.emit(this.candidatureFormation);
        this.calculTotauxAvisFormation(this.candidatureFormation.formationId);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/avis/avis.component.ts